<template>
<!--헤더-->
<div class="header">
	<div class="header__top">
		<h1 class="logo">
			<a href="#">
				<img class="logo--base" src="@/assets/common/ezims logo_W.png" alt="SuBPay" @click="goMenu('noticeList')">
				<img class="logo--sm" src="@/assets/common/ezims logo_W.png" alt="SuBPay" @click="goMenu('noticeList')" >
				<img class="logo--symbol" src="@/assets/common/ezims logo_W.png" alt="SuBPay" @click="goMenu('noticeList')">
			</a>
		</h1>
		<div class="login-info">
			{{checkUserId.organizationName}}
			<div class="login-info__detail">
				<p class="login-info__name"><em>{{checkUserId.memberName}}님</em> <span>환영합니다.</span></p>
				<div class="login-info__btns">
					<a href="#" class="login-info__setting" @click="goMenu('myPage')" >마이 페이지</a>
					<router-link to="/login" v-if="checkUserId.memberCode != ''" @click="logOut">로그아웃</router-link>
				</div>
			</div>
		</div>
	</div>
	<button type="button" class="btn__menu btn__gnb"><span></span></button>
	<div class="gnb">
		<p class="gnb__tit">MENU</p>
		<ul class="gnb__menu">
			<li v-if="checkUserId.privilege != 'user'" :class="{ 'on': isNoticeRoute }">
				<button type="button" class="icon-document-check" @click="goMenu('noticeList')"><span>공지 사항</span></button>
			</li>
			<li v-if="checkUserId.privilege == 'user'" :class="{ 'on': isNoticeRoute }">
				<button type="button" class="icon-document-check" @click="goMenu('noticeList')"><span>공지 사항</span></button>
			</li>
			<li v-if="checkUserId.privilege != 'user' && checkUserId.organizationCode !== 'A00002' " :class="{ 'on': isAdminRoute }">
				<button type="button" class="icon-person"><span>기관 관리</span></button>
				<ul>
					<li :class="{ 'on': isUserRoute }">
						<a @click="goMenu('admin')" src="">평가원 관리</a>
					</li>
					<li :class="{ 'on': isOrgMgrRoute }" v-if="checkUserId.privilege == 'sAdmin'" > 
						<a @click="goMenu('organizationMgr')" src="">기관 관리</a>
					</li>
					<!-- <li> 
						<a @click="goMenu('tempList')" src="">임시메뉴</a>
					</li> -->
				</ul>

				<!-- <button type="button" class="icon-person" @click="goMenu('admin')" ><span>기관 관리</span></button> -->
			</li>
			<li :class="{ 'on': isGiasRoute }" 
			 v-if="checkUserId.privilege == 'admin' || (checkUserId.privilege == 'user' && checkUserId.subRole == null)" >
				<button type="button" class="icon-alert"><span>평가</span></button>
				<ul>
					<li :class="{ 'on': isIQAGiasInputRoute }" 
					v-if="checkUserId.privilege == 'user' || checkUserId.privilege == 'sAdmin' ">
						<a @click="goMenu('IQAgiasInput')" src="">IQA내부통제체계 진단 실시</a>
					</li>
					<li :class="{ 'on': isIQCGiasInputRoute }" v-if="checkUserId.privilege == 'admin' || checkUserId.privilege == 'sAdmin' ">
						<a @click="goMenu('IQCgiasInput')" src="">IQC내부통제체계 진단 실시</a>
					</li>
					<!-- <li :class="{ 'on': isGiasStatsRoute }"> 
						<a @click="goMenu('giasStats')" src="">내부통제체계 진단 현황</a>
					</li> -->
					<!-- <li :class="{ 'on': is2024GiasStatsRoute }">
						<a @click="goMenu('gias2024Stats')" src="">2024년도 평가결과</a>
					</li>
					<li :class="{ 'on': isGiasEditRoute }" v-if="checkUserId.privilege == 'sAdmin'"> 
						<a @click="goMenu('giasEdit')" src="">GIAS항목편집</a>
					</li> -->
					<!-- <li> 
						<a @click="goMenu('tempList')" src="">임시메뉴</a>
					</li> -->
				</ul>
			</li>
			<li v-if="checkUserId.privilege == 'sAdmin'" :class="{ 'on': isOrgRoute }">
				<button type="button" class="icon-layout" @click="goMenu('organization')"><span>기관별 평가현황</span></button>
			</li>
			<li v-if="checkUserId.subRole != null " :class="{ 'on': isOrgRoute }">
				<button type="button" class="icon-layout" @click="goMenu('orgList')"><span>기관 평가하기</span></button>
			</li>


				<li v-if="checkUserId.privilege == 'sAdmin'" :class="{ 'on': isEvalRouter }">
				<button type="button" class="icon-person"><span>평가자 관리</span></button>
				<ul>
					<li :class="{ 'on': isCreateEval }">
						<a @click="goMenu('createEval')" src="">평가자 계정 생성</a>
					</li>
					<li :class="{ 'on': isEvalList }" v-if="checkUserId.privilege == 'sAdmin'" > 
						<a @click="goMenu('evalList')" src="">평가자 계정 관리</a>
					</li>
					<!-- <li> 
						<a @click="goMenu('tempList')" src="">임시메뉴</a>
					</li> -->
				</ul>

				<!-- <button type="button" class="icon-person" @click="goMenu('admin')" ><span>기관 관리</span></button> -->
			</li>
		</ul>
		<button type="button" class="icon-left-circle btn__collapse"><span>메뉴접기</span></button>
	</div>
	<div class="gnb__bg"></div>
</div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed,onMounted,ref  } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getCurrentInstance } from "vue";
const route = useRoute();
const router = useRouter()
const store = useStore()
const checkUserId = computed(() => store.state.temp.userInfo )

const goMenu = (name) => {
  if (route.name === name && name === "giasInput") {
	router.go(0);
  } else {
    router.push({ name })
  }
}

const isGiasRoute = computed(() => 
		route.name === 'IQAgiasInput' ||
		route.name === 'IQCgiasInput' ||
		route.name === 'giasStats' ||
		route.name === 'giasEdit' 
);

const isIQAGiasInputRoute = computed(() => 
		route.name === 'IQAgiasInput'
);

const isIQCGiasInputRoute = computed(() => 
		route.name === 'IQCgiasInput'
);

const isEvalList = computed(() => 
		route.name === 'evalList'
);

const isCreateEval = computed(() => 
		route.name === 'createEval'
);

const isGiasStatsRoute = computed(() => 
		route.name === 'giasStats' 
);

const is2024GiasStatsRoute = computed(() => 
		route.name === 'gias2024Stats' 
);

const isGiasEditRoute = computed(() => 
		route.name === 'giasEdit' 
);

const isUserRoute = computed(() => 
		route.name === 'admin' 
);

const isOrgMgrRoute = computed(() => 
		route.name === 'organizationMgr' 
);

const isAdminRoute = computed(() => 
		route.name === 'admin' ||
		route.name === 'adminView'||
		route.name === 'organizationMgr'
);

const isEvalRouter = computed(() => 
		route.name === 'evalList' ||
		route.name === 'createEval'
);

const isQGCRoute = computed(() => 
		route.name === 'QGC' 
		
);
const isNoticeRoute = computed(() => 
		route.name === 'noticeList' ||
		route.name === 'register' || 
		route.name === 'noticeView'||
		route.name === 'Home'
);

const isOrgRoute = computed(() => 
		route.name === 'organization' ||
		route.name === 'organizationView'||
		route.name === 'organizationGiasStats'||
		route.name === 'allOrgStats' ||
		route.name === 'orgList' 
);

const logOut = async () => {
	store.commit('temp/clearUserInfo')
	store.commit('grid/clearSearchParam')
}

onMounted(() => {
    console.log("맴버 코드 확인" ,checkUserId.value.memberCode)
	console.log("서브 코드 확인" ,checkUserId.value.subRole)
});
</script>

<style scoped>
/* 로고 스타일 */
.logo {
  font-size: 24px; /* 글자 크기 */
  font-weight: bold;
  color: white; /* 흰색으로 변경 */
  padding: 50px 20px; /* 패딩 추가 */
  border-radius: 5px; /* 모서리 둥글게 */
  text-align: center;
  display: inline-block;
}

/* 기관명 스타일 */
.login-info {
  color: white; /* 흰색으로 변경 */
  font-size: 16px;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 10px; /* 아래쪽 여백 추가 */
}

/* 회원 이름과 환영 메시지 스타일 */
.login-info__name {
  font-size: 14px;
  color: #ddd;
  margin-top: 10px; /* 위쪽 여백 추가 */
  display: block; /* 줄 바꿈 */
}

/* 기관명 안의 유저명 */
.login-info__name em {
  font-style: normal;
  font-weight: bold;
  color: #ffcc00; /* 강조 색상 (노랑) */
}

</style>
